import { IUserMilestone } from '../../IUserMilestone';

/**
 * Handles silencing multi user GTM V2 entry points *
 */
export const MULTI_USER_GTM_PDP_AND_BRAND_PAGE_V2_SILENCING =
  'MULTI_USER_GTM_PDP_AND_BRAND_PAGE_V2_SILENCING' as IUserMilestone.RetailerMilestone;
